
import { AddressType } from "src/Types/ReDoc/Address";
import { FiasType } from "src/Types/ReDoc/Fias";
import Regex from "./Regex";
import moment from "moment";


export const getText = ( value?: string|number|null, defaultTxt: string = "Не заполнено" ) => {
	if ( !!value )
		return value.toString();
	return defaultTxt;
};

export const getGender = ( gender?: string | null ): string => {
	switch( gender ) {
		case "male": return "Мужской";
		case "female": return "Женский";
		default: return "Не заполнено";
	}
};

export const dateToString = ( data: string|Date = '', isShort: boolean = true ): string => {
	const str = data?.toString() || "";
	if ( !!str ) {
		const date = moment( str, Regex.ISO_8601.test(str) ? '' : 'L'  );
		if ( isShort )
			return date.format('L');
		else 
			return date.format('LL');
	}
	return "Не заполнено";
};

export const getTextByManualAddress = ( address?: AddressType ): string => {
	if ( !!address ) {
		let result: string = "";
		if ( !!address.index )
			result = address.index + ", ";
		if ( !!address.region ) 
			result += address.region;
		if ( !!address.state ) 
			result += ", " + address.state;
		if ( !!address.city ) 
			result += ", " + address.city;
		if ( !!address.cityDistrict ) 
			result += ", " + address.cityDistrict;
		if ( !!address.street ) 
			result += ", " + address.street;
		if ( !!address.house ) 
			result += ", дом " + address.house;
		if ( !!address.housing ) 
			result += ", корпус " + address.housing;
		if ( !!address.structure ) 
			result += ", строение " + address.structure;
		if ( !!address.flat ) 
			result += ", кв./офис " + address.flat;
		if ( !!address.dwelling ) 
			result += ", жил. помещение " + address.dwelling;
		return result;
	}
	else
		return "Не заполнено";
};

export const getTextByFias = ( fias?: FiasType ): string => {
	if ( !!fias ) {
		let result: string = "";
		if ( !!fias.postalIndex )
			result = fias.postalIndex + ", ";
		if ( !!fias.regionName ) 
			result += fias.regionName;
		if ( !!fias.stateName ) 
			result += ", " + fias.stateName;
		if ( !!fias.cityName ) 
			result += ", " + fias.cityName;
		if ( !!fias.cityDistrictName ) 
			result += ", " + fias.cityDistrictName;
		if ( !!fias.streetName ) 
			result += ", " + fias.streetName;
		if ( !!fias.house ) 
			result += ", дом " + fias.house;
		if ( !!fias.corpuse ) 
			result += ", корпус " + fias.corpuse;
		if ( !!fias.flat ) 
			result += ", кв./офис " + fias.flat;
		if ( !!fias.dwelling ) 
			result += ", жил. помещение " + fias.dwelling;
		return result;
	}
	else
		return "Не заполнено";
};

export const deleteTagsFromText = ( value: string ): string => value.replace(/<\/?[a-zA-Z]+>/gi,'');


/**
 * Безопасный декодер для percent-encoded строк.
 * Не кидает исключение при некорректной/частично закодированной строке.
 */
export const safeDecodeURIComponent = ( value?: string | null ): string => {
    if ( value === undefined || value === null ) return "";
    const stringValue = value.toString();
    try {
        return decodeURIComponent( stringValue );
    }
    catch {
        // Попытка частичной нормализации: заменяем одиночные '%' на '%25'
        try {
            const normalized = stringValue.replace(/%(?![0-9A-Fa-f]{2})/g, '%25');
            return decodeURIComponent( normalized );
        }
        catch {
            return stringValue;
        }
    }
};
